export default __webpack_public_path__ + "static/media/close_circle_dark.f2b1932e.svg";